<!-- @format -->
<div
	id="pdp-fulfillment-subtext"
	[class.hmf-pl-s]="!isBundle()"
	[class.hmf-pl-md-0]="!isBundle()">
	<pdp-feature-in-store-pickup-subtext [isBundle]="isBundle()">
	</pdp-feature-in-store-pickup-subtext>
	<pdp-feature-same-day-delivery-subtext></pdp-feature-same-day-delivery-subtext>
	<pdp-feature-ship-to-me-subtext [isBundle]="isBundle()"> </pdp-feature-ship-to-me-subtext>
</div>
